// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__f7xh9","box":"WorkspacesBox_box__2qzMz","node":"WorkspacesBox_node__2w4_n"};